module.exports = "<%=baseUrl%>/38861cba61c66739c1452c3a71e39852.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/core/public/Roboto.ttf
// module id = 169
// module chunks = 0